import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import slugify from '@sindresorhus/slugify';

import Link from './renderers/Link';
import Heading from './renderers/Heading';
import Button from './Button';
import RemixArrowDownLineSVG from '../svg/icons/remix-arrow-down-line.svg';

const TOC = ({ links, togglerRequired, textSizes, heading }) => {
  const [isOpen, setOpen] = useState(true);
  const toggleNav = useCallback(() => setOpen((status) => !status), []);

  const headingClass =
    'font-black leading-snug text-xl pt-8 px-12 md:px-8 md:text-lg lg:px-6 xl:text-xl';
  const ulClass = classnames('list-none px-12 pb-6 w-full', {
    'pt-2 md:pl-8 md:pr-4 lg:pl-6': isOpen,
    'xl:p-0': !isOpen,
  });
  const liClass = classnames('hover:underline leading-tight my-4 xl:my-2', {
    'xl:invisible xl:h-0': !isOpen,
  });

  return (
    <nav className="box-border relative rounded-md w-full bg-gray-200 mb-6">
      {togglerRequired === true ? (
        <Button
          className="xl:w-full"
          colour="purple"
          appearance="outline"
          onClick={toggleNav}
        >
          <div className="flex flex-row items-center w-full">
            <Heading
              level={4}
              className={headingClass}
              children={heading || 'Table of contents'}
            />

            <RemixArrowDownLineSVG
              className={`h-4 xl:order-last fill-current w-5 duration-100 transform transition-transform ${
                isOpen && '-rotate-90'
              }`}
            />
          </div>
        </Button>
      ) : (
        <h4 className={headingClass}>{heading || 'Table of contents'}</h4>
      )}
      <ul className={ulClass}>
        {links.map((link, index) => (
          <li key={index} className={liClass}>
            <Link
              className={
                textSizes
                  ? classnames('text-cornflower', textSizes)
                  : 'text-base xl:text-sm text-cornflower'
              }
              href={
                '#' +
                slugify(link, {
                  customReplacements: [
                    ['/', ''],
                    ['.', ''],
                  ],
                  decamelize: false,
                })
              }
            >
              {link}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TOC;
